var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWallet = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.001h-16c-1.105 0-2-0.895-2-2v0-16c0-1.105 0.895-2 2-2v0h16c1.105 0 2 0.895 2 2v0 4h-6c-1.105 0-2 0.895-2 2v0 4c0 1.105 0.895 2 2 2v0h6v4c0 1.105-0.895 2-2 2v0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.001h-3c-1.105 0-2-0.895-2-2v0-2c0-1.105 0.895-2 2-2v0h3c1.105 0 2 0.895 2 2v0 2c0 1.105-0.895 2-2 2v0zM18 11.001c-0.552 0-1 0.448-1 1v0c0 0.552 0.448 1 1 1v0c0.552 0 1-0.448 1-1v0c0-0.552-0.448-1-1-1v0z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWallet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wallet.05861a73.svg";
export { ForwardRef as ReactComponent };